import { usePrivy } from "@privy-io/react-auth";
import { useAuth } from "contexts/authContext";
import slugs from "navigation/slugs";
import { useState } from "react";
import { redirect } from "react-router";

export const useController = () => {
  const { updateToken } = useAuth();
  const { user, logout } = usePrivy();

  const [currentTab, setCurrentTab] = useState("Trending");

  const handleLogout = async () => {
    try {
      await logout();
      updateToken("");
      redirect(slugs.login);
    } catch (error) {
      console.error("An error occurred", error);
    }
  };

  return {
    user,
    handleLogout,
    currentTab,
    setCurrentTab,
  };
};
